/**
 * Which sidebar tab is the current page? The panels compared the address
 * exactly, so any deeper page (a course's edit page, an exam being edited,
 * /instructor itself) highlighted nothing and you could not tell where you
 * were (2026-10-14). The tab whose address is the longest prefix of the
 * current one wins; `alsoFor` lists other addresses a tab owns.
 */
export interface NavTarget {
  href: string;
  alsoFor?: string[];
  /** Addresses this tab owns exactly, not their sub-pages (e.g. /instructor). */
  exactFor?: string[];
}

export function activeNavHref(location: string, items: NavTarget[]): string | null {
  const path = location.split(/[?#]/)[0].replace(/\/+$/, '') || '/';
  let best: { href: string; len: number } | null = null;
  for (const item of items) {
    if ((item.exactFor ?? []).some((e) => (e.replace(/\/+$/, '') || '/') === path)) return item.href;
  }
  for (const item of items) {
    for (const base of [item.href, ...(item.alsoFor ?? [])]) {
      const b = base.replace(/\/+$/, '') || '/';
      const hit = path === b || path.startsWith(b + '/');
      // An exact match on a tab's own address always wins over a prefix.
      const len = path === b ? Number.MAX_SAFE_INTEGER : b.length;
      if (hit && (!best || len > best.len)) best = { href: item.href, len };
    }
  }
  return best?.href ?? null;
}
